export enum CancellationReason {
  TOO_EXPENSIVE_OVER_MY_BUDGET = "TOO_EXPENSIVE_OVER_MY_BUDGET",
  TOO_EXPENSIVE_OTHER_BRANDS_ARE_CHEAPER = "TOO_EXPENSIVE_OTHER_BRANDS_ARE_CHEAPER",
  TOO_EXPENSIVE_NOT_WORTH_THE_COST = "TOO_EXPENSIVE_NOT_WORTH_THE_COST",
  TOO_EXPENSIVE_DONT_WANT_TO_PAY_FOR_DELIVERY = "TOO_EXPENSIVE_DONT_WANT_TO_PAY_FOR_DELIVERY",

  FREEZER_SPACE_ACCUMULATION = "FREEZER_SPACE_ACCUMULATION",
  FREEZER_SPACE_NOT_ENOUGH_SPACE = "FREEZER_SPACE_NOT_ENOUGH_SPACE",

  SUBSCRIPTION_DOESNT_WORK_NEED_LESS_FOOD = "SUBSCRIPTION_DOESNT_WORK_NEED_LESS_FOOD",

  COMING_BACK_FEEDING_OTHER_FOODS_ALONGSIDE_KATKIN = "COMING_BACK_FEEDING_OTHER_FOODS_ALONGSIDE_KATKIN",

  OTHER = "OTHER",
}
